export default "__VITE_ASSET__7d2b1aa5__"